// @flow
import * as React from 'react';
import SidePane from 'esm-web-pro/components/layout/SidePane';
import { FormattedMessage } from 'react-intl';
import ApiForm from 'esm-web-pro/containers/forms/ApiForm';
import type { SwitchDataPort } from 'esm-web-pro/types/networks';
import { bindActionCreators } from 'redux';
import { closePanel as closePanelAction } from 'esm-web-pro/redux/side-panel';
import { connect } from 'react-redux';

export const ADD_SFP_KEY = 'ADD_SFP_KEY';

type Props = {
    port: SwitchDataPort,
    onClose: Function,
    onSave: Function,
    closePanel: ?(key: string, skipSensitivity: boolean) => { key: string },
    openInitially?: boolean,
    panelTitle: Object,
};

const AddSFP = (props: Props) => {
    const {
        port, onClose, onSave, closePanel, openInitially, panelTitle,
    } = props;
    return (
        <SidePane
            id={ADD_SFP_KEY + port.data_port_number}
            openInitially={openInitially}
            title={panelTitle}
        >
            <ApiForm
                resourceName="sfp"
                excludeFields={['data_port']}
                onSubmit={(values) => ({ ...values, data_port: port.uuid })}
                onClose={() => {
                    closePanel(ADD_SFP_KEY + port.data_port_number);
                    onClose();
                }}
                onSave={() => {
                    closePanel(ADD_SFP_KEY + port.data_port_number, true);
                    onSave();
                }}
                height="100%"
            />
        </SidePane>
    );
};

const mapDispatchToProps = (dispatch) => (bindActionCreators(
    { closePanel: closePanelAction },
    dispatch,
));

AddSFP.defaultProps = {
    openInitially: false,
};

export default connect(null, mapDispatchToProps)(AddSFP);
